const ICON = "/assets/game-icons";

// featured games get large bento tiles
export const GAMES = [
  { name: "Fortnite", slug: "fortnite", featured: true },
  { name: "Minecraft", slug: "minecraft", featured: true },
  { name: "Rocket League", slug: "rocket-league", featured: true },
  { name: "Valorant", slug: "valorant" },
  { name: "Apex Legends", slug: "apex-legends" },
  { name: "Call of Duty: Warzone", slug: "cod-warzone" },
  { name: "COD: Black Ops Cold War", slug: "cod-black-ops-cold-war" },
  { name: "COD: Modern Warfare II", slug: "cod-modern-warfare-2" },
  { name: "Counter-Strike: GO", slug: "counter-strike-go" },
  { name: "DOTA 2", slug: "dota-2" },
  { name: "FIFA 2023", slug: "fifa-2023" },
  { name: "Halo: MCC", slug: "halo-mcc" },
  { name: "Hearthstone", slug: "hearthstone" },
  { name: "League of Legends", slug: "league-of-legends" },
  { name: "Madden 2023", slug: "madden-2023" },
  { name: "Overwatch 2", slug: "overwatch-2" },
  { name: "PUBG", slug: "pubg" },
  { name: "Rainbow Six Siege", slug: "rainbow-six-siege" },
  { name: "Roblox", slug: "roblox" },
  { name: "Rogue Company", slug: "rogue-company" },
  { name: "StarCraft II", slug: "starcraft-2" },
  { name: "Super Mario Party", slug: "super-mario-party" },
  { name: "Super Smash Bros Ultimate", slug: "super-smash-bros-ultimate" },
  { name: "Tekken 7", slug: "tekken-7" },
  { name: "World of Warcraft: Shadowlands", slug: "wow-shadowlands" },
].map((g) => ({ ...g, icon: `${ICON}/${g.slug}.png` }));

export const SPONSORS = [
  { name: "Bloody Tech", file: "bloody-tech" },
  { name: "Pixio Gaming", file: "pixio-gaming" },
  { name: "GFuel", file: "gfuel" },
  { name: "Warren James", file: "warren-james" },
  { name: "Techie Factory / SGF Events", file: "techie-factory-sgf-events" },
  { name: "Esports Coaching Academy", file: "esports-coaching-academy" },
  { name: "Children's Miracle Network", file: "childrens-miracle-network" },
].map((s) => ({ ...s, src: `/assets/sponsors/${s.file}.png` }));

export const SERVICES = [
  "Birthday Parties",
  "School Events",
  "Corporate Events",
  "Fundraisers",
  "Church Lock-Ins",
];

export const PACKAGES = [
  {
    name: "2 Hour Party Package",
    price: "$395",
    ages: "6+",
    includes: [
      "2 hrs with host",
      "2 Xbox Series X",
      "2 PS5 Slim",
      "2 Switch OLED",
      "1 Oculus Quest 3",
      "T-Mobile 5G",
    ],
  },
  {
    name: "3 Hour Party Package",
    price: "$475",
    ages: "6+",
    includes: [
      "3 hrs with host",
      "2 Xbox Series X",
      "2 PS5 Slim",
      "2 Switch OLED",
      "1 Oculus Quest 3",
      "T-Mobile 5G",
    ],
  },
  {
    name: "Gaming Fanatic Package",
    price: "$525",
    ages: "6+",
    featured: true,
    includes: [
      "Everything in 3 Hour Package",
      "+ 4 computer gaming systems",
      "3 hrs with host",
      "T-Mobile 5G",
    ],
  },
  {
    name: "Ultimate Gamer Esports Package",
    price: "Contact for pricing",
    ages: "10+",
    includes: [
      "10 computer gaming systems",
      "T-Mobile 5G",
      "3 hrs with host",
      "Full esports lounge setup",
    ],
  },
];

export const CAMP_TYPES = ["Free Play", "Adventure Camp", "Minecraft", "Rocket League", "And More!"];

export const CONTACT = {
  phone: "956-684-8211",
  city: "Mercedes, Texas",
  area: "Mercedes / McAllen, TX (Rio Grande Valley)",
  hours: "Sun–Sat: 9:00 AM – 7:00 PM",
  fleet: "10 Gaming PCs · 2 PlayStations · 2 Xboxes · 2 Nintendo Switches · 1 Oculus",
};

export const QUOTES = {
  home: [
    {
      quote:
        "I've missed more than 9,000 shots in my career. I've lost almost 300 games. I have failed over and over. And that is why I succeed.",
      author: "Michael Jordan",
    },
    { quote: "Winning isn't everything, but wanting to win is.", author: "Vince Lombardi" },
    { quote: "You miss 100% of the shots you don't take.", author: "Wayne Gretzky" },
  ],
  about: [
    {
      quote: "Talent wins games, but teamwork and intelligence win championships.",
      author: "Michael Jordan",
    },
    { quote: "It's not whether you get knocked down, it's whether you get up.", author: "Vince Lombardi" },
    { quote: "The way a team plays as a whole determines its success.", author: "Babe Ruth" },
  ],
  events: [
    {
      quote: "Do you know what my favorite part of the game is? The opportunity to play.",
      author: "Mike Singletary",
    },
    { quote: "Champions keep playing until they get it right.", author: "Billie Jean King" },
    { quote: "The more difficult the victory, the greater the happiness in winning.", author: "Pelé" },
  ],
  camps: [
    {
      quote: "Success is not final, failure is not fatal: it is the courage to continue that counts.",
      author: "Winston Churchill",
    },
    {
      quote:
        "Ability is what you're capable of doing. Motivation determines what you do. Attitude determines how well you do it.",
      author: "Lou Holtz",
    },
    {
      quote: "It's not about being the best. It's about being better than you were yesterday.",
      author: "Athletic Mantra",
    },
  ],
};
